import { ENewReviewFlow } from '../../types/newReview';
import { ETripStatus } from '../../repositories/dailyrent/entities/request/PublicV1ReviewSaveRequestSchema';

export function mapFlowToTripStatus(flow: ENewReviewFlow | null) {
  return {
    [ENewReviewFlow.Success]: ETripStatus.Success,
    [ENewReviewFlow.Fail]: ETripStatus.Fail,
    [ENewReviewFlow.FailedToAgree]: ETripStatus.FailedToAgree,
  }[flow || ENewReviewFlow.FailedToAgree];
}
